<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
    <circle cx="12" cy="12" r="10" fill="currentColor" opacity="0.2" />
    <path d="M16,9V19a1,1,0,0,1-1,1H9a1,1,0,0,1-1-1V9" fill="none" stroke="currentColor" stroke-width="2" />
    <rect x="8" y="5" width="8" height="2" rx="0.5" fill="currentColor" />
    <line x1="6" y1="7" x2="18" y2="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
    <line x1="10" y1="11" x2="10" y2="17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    <line x1="14" y1="11" x2="14" y2="17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
  </svg>
</template>

<script>
export default {
  name: "DeleteIcon"
}
</script> 